class PlanUpdater extends HTMLElement {
  constructor() {
    super();
    this.planSelector = this.querySelector("select");
    this.loadingSpinner =
      this.closest(".cart-item").querySelector(".loading-spinner");
    this.cartItemsPrice = this.closest(".cart-item").querySelector(
      ".cart-item__price-wrapper"
    );
    this.firstOptionText = this.planSelector.options[0].textContent;
    this.planSelector.addEventListener("mousedown", () => {
      const firstOption = this.planSelector.options[0];
      if (firstOption) {
        firstOption.textContent = "One time purchase";
      }
    });
    this.planSelector.addEventListener("blur", () => {
      const firstOption = this.planSelector.options[0];
      if (firstOption) {
        firstOption.textContent = this.firstOptionText;
      }
    });
    this.planSelector.addEventListener("change", (e) => {
      const sellingPlanId = e.target.value;
      const variantId = this.getAttribute("variant-id");
      const quantity = parseInt(this.getAttribute("quantity")) || 1;
      const lineIndex = parseInt(this.getAttribute("data-index"));
      this.loadingSpinner.classList.remove("hidden");
      this.cartItemsPrice.classList.add("hidden");
      const body = JSON.stringify({
        line: lineIndex,
        quantity: quantity,
        id: variantId,
        selling_plan: sellingPlanId,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        body: body,
      })
        .then((res) => res.json())
        .then((cart) => {
          const sections = cart.sections || {};
          const cartDrawerHtml = sections["cart-drawer"];
          const parser = new DOMParser();
          if (cartDrawerHtml) {
            const drawerDoc = parser.parseFromString(
              cartDrawerHtml,
              "text/html"
            );
            const newDrawer = drawerDoc.querySelector(".drawer__inner");
            const existingDrawer = document.querySelector(".drawer__inner");
            if (newDrawer && existingDrawer) {
              existingDrawer.innerHTML = newDrawer.innerHTML;
            }
          }

          const cartCountElements = document.querySelectorAll(
            "[data-header-cart-count]"
          );
          cartCountElements.forEach((element) => {
            if (cart.item_count > 0) {
              element.setAttribute("data-header-cart-count", cart.item_count);
              element.classList.add("visible");
            } else {
              element.removeAttribute("data-header-cart-count");
              element.classList.remove("visible");
            }
          });

          if (typeof publish === "function") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "plan-updater",
              cartData: cart,
            });
          }
        })
        .catch((err) => {
          console.error("Error updating selling plan:", err);
        })
        .finally(() => {
          this.loadingSpinner.classList.add("hidden");
          this.cartItemsPrice.classList.remove("hidden");

          const firstOption = this.planSelector.options[0];
          if (firstOption) firstOption.textContent = this.firstOptionText;
        });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
    ];
  }
}

customElements.define("plan-updater", PlanUpdater);
